<template>
    <div class="language-configurations-page">
            <div class="language-configurations-page__row">
                <h1 class="pagetitle left">
                    {{ title }}
                </h1>
                <div class="language-configurations-page__buttons">
                  <transition name="fade">
                    <button
                        v-bind:class="['btn', 'right', TabulationValue === 0 ? 'active' : '']"
                        v-on:click="setTabValue(0)"
                        >
                        Language combinations
                    </button>
                  </transition>

                  <transition name="fade">
                     <button
                        v-bind:class="['btn', 'right', TabulationValue === 1 ? 'active' : '']"
                        v-on:click="setTabValue(1)"
                        >
                        Languages
                    </button>
                  </transition>

                </div>
            </div>

        <hr />

          <div  v-if="TabulationValue === 1">
            <transition name="fade">
                <languagesComponent />
              </transition>
          </div>

          <div v-if="TabulationValue === 0">
            <transition name="fade">
              <languageCombinationsComponent />
            </transition>
          </div>

    </div>
</template>

<script>
import Vue from 'vue';
import languagesComponent from './languages';
import languageCombinationsComponent from './languageCombinations';

export default Vue.extend({
  components: {
    languagesComponent,
    languageCombinationsComponent,
  },
  data() {
    return {
      TabulationValue: 1,
    };
  },
  computed: {
    title() {
      return this.TabulationValue === 0 ? 'Language combinations' : 'Languages';
    },
  },
  methods: {
    setTabValue(val) {
      this.TabulationValue = val;
    },
  },
});
</script>

<style src="./languagesConfiguration.style.css"></style>
